import { AppLayout } from 'layouts';
import type { Profile } from 'models';
import type { ReactNode } from 'react';

type P = {
  children: (member: Profile) => ReactNode;
  header?: (member: Profile) => ReactNode;
  viewer: Profile;
};

const ViewerLayout = ({ children, header, viewer }: P) => (
  <AppLayout>
    {header?.(viewer)}
    {children(viewer)}
  </AppLayout>
);

export default ViewerLayout;
